import { useMutation, useQueryClient } from '@tanstack/react-query';
import { resendInvite } from '../api/userManagementApi';
import { userKeys } from './userKeys';

/**
 * Mutation hook for resending an invitation.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useResendInvite() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (invitationId: string) => resendInvite(invitationId),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userKeys.pendingInvites() });
    },
  });
}
